import { IExpenseCategory } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		name?: string
		slug?: string
		note?: string
	}
}

export async function expenseCategoryUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/expense/category/update/v1"
	const requester = new ApiRequester<RequestDataShape, IExpenseCategory>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
